import React from 'react';
import './AdminViewToggle.scss';
import { HiOutlineUserGroup, HiOutlineUser } from 'react-icons/hi';

const AdminViewToggle = ({ isActive, onToggle, isCollapsed }) => {
  return (
    <div className="admin-view-toggle">
      {!isCollapsed && <span className="toggle-label">View Mode:</span>}
      
      <button 
        className={`toggle-button ${isActive ? 'active' : ''}`}
        onClick={onToggle}
        title={isActive ? 'Switch to User View' : 'Switch to Admin View'}
      >
        <span className="toggle-track">
          <span className="toggle-indicator"></span>
        </span>
        <span className="toggle-icons">
          <HiOutlineUserGroup className={`admin-icon ${isActive ? 'active' : ''}`} />
          <HiOutlineUser className={`user-icon ${!isActive ? 'active' : ''}`} />
        </span>
        {!isCollapsed && (
          <span className="toggle-text">
            {isActive ? 'Admin' : 'User'}
          </span>
        )}
      </button>
    </div>
  );
};

export default AdminViewToggle; 